/**
 * Bottone "Esci" per l'header dell'area owner (dashboard + gestione hotel).
 *
 * Chiama POST /auth/owner-logout su api-cloud (clear del cookie HttpOnly
 * `hm_owner_at`), poi — anche se la rete fallisce (best-effort: la sessione
 * UI va comunque chiusa) — pulisce la session store owner e torna a
 * /owner/login. Tap target >= 44px (h-11 / min-w-11).
 */
import { LogOut } from '@hotel-manager/ui/icons';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { cloudApi } from '../../api/cloud-client.js';
import { useOwnerSession } from '../../stores/owner.js';

export function OwnerLogoutButton() {
  const navigate = useNavigate();
  const clear = useOwnerSession((s) => s.clear);

  const mutation = useMutation({
    mutationFn: () => cloudApi<{ ok: true }>('/auth/owner-logout', { method: 'POST' }),
    // onSettled (non onSuccess): anche se il cloud non risponde, la sessione
    // UI viene chiusa. Il cookie HttpOnly eventualmente superstite scade da
    // solo (TTL breve) e RequireOwner riporta comunque al login.
    onSettled: () => {
      clear();
      navigate('/owner/login', { replace: true });
    },
  });

  return (
    <button
      type="button"
      onClick={() => mutation.mutate()}
      disabled={mutation.isPending}
      aria-label="Esci"
      className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-border-base bg-bg-card px-3 h-11 min-w-11 text-[13px] font-medium text-text-secondary hover:bg-bg-muted transition-colors disabled:opacity-50 shrink-0"
    >
      <LogOut size={15} strokeWidth={1.75} />
      <span className="hidden sm:inline">Esci</span>
    </button>
  );
}
